import styled from 'styled-components';
import theme from '@css/theme';
import is from 'typescript-styled-is';
import { FixMe } from '@utils/types';

interface IProps {
  fontSize?: string;
  color?: string;
  fontWeight?: string;
}

interface ILabelProps {
  fontFamily?: string;
  fontStyle?: string;
  fontWeight?: number;
  fontSize?: string;
  lineHeight?: string;
  color?: string;
  secondary?: boolean;
}

/** @deprecated */
const label = (props: ILabelProps) => `
  font-family: ${props.fontFamily || 'Noto Sans'};
  font-style: ${props.fontStyle || 'normal'};
  font-weight: ${props.fontWeight || 500};
  font-size: ${props.fontSize || '16px'};
  line-height: ${props.lineHeight || '22px'};
  color: ${props.color || theme.color.neutral1};
`;

/** @deprecated */
export const Label = styled.span`
  ${label}
  ${is('secondary')`
    color: ${theme.color.neutral3};
  `};
`;

/** @deprecated */
export const LabelDiv = styled.div`
  ${label}
`;

/** @deprecated */
export const LabelSmall = styled.div`
  ${label}
  font-size: 12px;
  color: ${(props) => props.color};
`;

/** @deprecated */
export const LabelMedium = styled.div`
  ${label}
  font-size: 14px;
  ${is('secondary')`
    color: ${theme.color.neutral3};
  `};
  word-wrap: normal;
`;

/** @deprecated */
export const LabelLarge = styled.div`
  ${label}
  font-size: 16px;
  ${is('secondary')`
    color: ${theme.color.neutral3};
  `};
`;

/** @deprecated */
const text = (props: FixMe) => `
  font-family: Noto Sans;
  font-style: normal;
  font-weight: ${props.fontWeight || 'normal'};;
  font-size: ${props.fontSize || '12px'};
  line-height: 20px;
  color: ${props.color || props.theme.color.neutral1};
`;

/** @deprecated */
export const Text = styled.span<IProps>`
  ${text}
`;

/** @deprecated */
export const TextDiv = styled.div<IProps>`
  ${text}
`;

interface ISubHeaderProps extends IProps {
  lineHeight?: string;
}

/** @deprecated */
const subHeader = (props: ISubHeaderProps) => `
font-family: Noto Sans;
font-style: normal;
font-weight: ${props.fontWeight || 600};
line-height: ${props.lineHeight || '22px'};
font-size: ${props.fontSize || '16px'};
color: ${props.color || theme.color.neutral1};
`;

/** @deprecated */
export const SubHeaderDiv = styled.div<IProps>`
  ${subHeader}
`;

export const H1 = styled.div`
  font-family: ${theme.text.fontFamily};
  font-style: normal;
  font-weight: normal;
  font-size: 1.75rem;
  line-height: normal;
  color: ${theme.text.color.primary};
`;

export const H2 = styled.div`
  font-family: ${theme.text.fontFamily};
  font-weight: 600;
  font-size: 1.5rem;
  line-height: normal;
  color: ${theme.text.color.primary};
`;

export const H3 = styled.div`
  font-family: ${theme.text.fontFamily};
  font-weight: 600;
  font-size: 1.25rem;
  line-height: normal;
  color: ${theme.text.color.primary};
`;

export const H4 = styled.div`
  font-family: ${theme.text.fontFamily};
  font-weight: 500;
  font-size: 1.125rem;
  line-height: normal;
  color: ${theme.text.color.primary};
`;

export const NewLabel = styled.div`
  font-family: ${theme.text.fontFamily};
  font-weight: 500;
  font-size: 1rem;
  color: ${theme.text.color.primary};
`;

export const Body = styled.div<{ secondary?: boolean }>`
  font-family: ${theme.text.fontFamily};
  font-weight: normal;
  font-size: 1rem;
  color: ${({ secondary }) => (secondary ? theme.text.color.secondary : theme.text.color.primary)};
`;

export const TableBody = styled.div`
  font-family: ${theme.text.fontFamily};
  font-weight: normal;
  font-size: 0.875rem;
  color: ${theme.text.color.primary};
`;

export const TableHeader = styled.div`
  font-family: ${theme.text.fontFamily};
  font-weight: bold;
  font-size: 0.875rem;
  color: ${theme.text.color.primary};
`;

const getSubtextColor = (error?: boolean, secondary?: boolean) => {
  if (error) {
    return theme.color.error;
  }
  return secondary ? theme.text.color.secondary : theme.text.color.primary;
};

export const Subtext = styled.div<{ error?: boolean; secondary?: boolean }>`
  font-family: ${theme.text.fontFamily};
  font-weight: normal;
  font-size: 0.875rem;
  color: ${({ error, secondary }) => getSubtextColor(error, secondary)};
`;

export const Caption = styled.div<{ secondary?: boolean }>`
  font-family: ${theme.text.fontFamily};
  font-weight: normal;
  font-size: 0.75rem;
  color: ${({ secondary }) => (secondary ? theme.text.color.secondary : theme.text.color.primary)};
`;
